import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Card } from '@/components/ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';
import { DailyData } from '../utils/mockData';

interface ChartConversaoDiaProps {
  data: DailyData[];
}

export function ChartConversaoDia({ data }: ChartConversaoDiaProps) {
  useLanguage();
  const formattedData = data.map(d => ({
    ...d,
    dateFormatted: new Date(d.date).toLocaleDateString(getInterfaceLanguage(), { day: '2-digit', month: '2-digit' })
  }));

  return (
    <Card className="border border-[#E5E7EB] rounded-[14px] p-6">
      <div className="mb-4">
        <h3 className="text-[15px] font-semibold text-[#101828]">{translateInterfaceText("Conversão por Dia")}</h3>
        <p className="text-[12px] text-[#667085] mt-1">{translateInterfaceText("Últimos 30 dias")}</p>
      </div>

      <div className="h-[280px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={formattedData}>
            <defs>
              <linearGradient id="colorLeads" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#2F6FED" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#2F6FED" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis
              dataKey="dateFormatted"
              stroke="#667085"
              fontSize={11}
              tickLine={false}
            />
            <YAxis
              stroke="#667085"
              fontSize={11}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                fontSize: '12px'
              }}
            />
            <Area
              type="monotone"
              dataKey="leads"
              stroke="#2F6FED"
              strokeWidth={2}
              fill="url(#colorLeads)"
              dot={{ fill: '#2F6FED', r: 4 }}
              activeDot={{ r: 6 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
